<!-- src/components/sections/AboutTeaser.svelte -->
<script>
  import logo from '../../assets/down-to-earth-logo-arrow-sign.svg';
</script>

<section class="about_teaser" aria-labelledby="about-teaser-heading">
  <div class="container">
    <img src={logo} alt="Down to Earth Guides Logo" class="teaser_logo" width="96" height="96" />
    <div class="teaser_text">
      <h2 id="about-teaser-heading" class="marker-font">Who's behind this</h2>
      <p>
        I'm <strong>Tom Voltz</strong> — a real builder who explains AI without the
        jargon, and the founder of Usefulbots.com. I work with owners and execs at
        20–500-person companies who find big consulting intimidating and overpriced.
        I don't drop a deck and leave; I make your people capable.
      </p>
      <p class="bear">
        There's an old bear story I tell: you don't have to outrun the bear, just the
        other camper. The 2026 version? You already started running — the AI Reality
        Check makes sure you're running in the right direction.
      </p>
      <a class="teaser_link" href="/about">More about Tom →</a>
    </div>
  </div>
</section>

<style>
  .about_teaser {
    background: var(--color-background);
    padding: 4.5rem 0;
  }

  .container {
    max-width: 900px;
    margin: 0 auto;
    padding: 0 2rem;
    display: flex;
    gap: 2.5rem;
    align-items: flex-start;
  }

  .teaser_logo {
    width: 96px;
    height: 96px;
    flex-shrink: 0;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  }

  .teaser_text h2 {
    font-size: 2rem;
    color: var(--color-text);
    margin: 0 0 1rem;
  }

  .teaser_text p {
    font-size: 1.1rem;
    line-height: 1.65;
    color: var(--color-text-muted);
    margin: 0 0 1rem;
  }

  .teaser_text strong {
    color: var(--color-text);
  }

  .bear {
    font-style: italic;
  }

  .teaser_link {
    font-size: 1.05rem;
    color: var(--color-primary);
    font-weight: 500;
  }

  @media (max-width: 768px) {
    .container {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 1.5rem;
    }

    .teaser_text h2 {
      font-size: 1.6rem;
    }
  }
</style>
